import { Action } from './Action';
import { ConsentEventListener } from './ConsentEventListener';
import { ConsentEventType } from './ConsentEventType';

const _listeners: ConsentEventListener[] = [];

export async function Publish(type: ConsentEventType): Promise<void> {
  _listeners.forEach((listener) => {
    if (listener.Type !== type) return;
    (async () => listener.Action())();
  });
}

export function Subscribe(type: ConsentEventType, action: Action): ConsentEventListener {
  const listener = new ConsentEventListener(type, action);
  _listeners.push(listener);
  return listener;
}

export function Unsubscribe(listener: ConsentEventListener): void {
  _listeners.splice(_listeners.indexOf(listener), 1);
}
